// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider-root-972d943fb0dfecda4bb28bdde8b82515"};